module.exports = {"systemInfo":{"title":"System Info","name":"Name","description":"Description","updateLog":"Update Log","version":"Version","":""}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/systemInfo.json
// module id = 694
// module chunks = 63